var exports = {
  "jF": "River__JJveXw",
  "fh": "Cell__cNExxX",
  "mO": "Wrapper__edLOsH",
  "UC": "Content__IsCNh3",
  "tK": "SubTitle__eOO7v5",
  "VY": "Description__e4LbDy",
};

module.exports = exports;
